<template>
  <v-card 
    class="mb-6 card-shadow border-radius-xl year-selector-card" 
    :class="{ 'year-selector-sticky': sticky }"
  >
    <v-card-text class="py-3 px-4">
      <div class="d-flex align-center">
        <v-btn
          icon
          small
          elevation="0"
          class="me-2"
          :disabled="!canGoPreviousYear"
          @click="goToPreviousYear"
        >
          <i class="material-icons-round">chevron_left</i>
        </v-btn>
        
        <v-select
          :value="selectedYear || currentYear"
          :items="getYears"
          @change="changeYear"
          solo
          flat
          hide-details
          dense
          class="year-select"
          style="max-width: 140px;"
        >
          <template v-slot:prepend-inner>
            <i class="material-icons-round me-2" style="font-size: 20px;">event</i>
          </template>
        </v-select>
        
        <v-btn
          icon
          small
          elevation="0"
          class="ms-2"
          :disabled="!canGoNextYear"
          @click="goToNextYear"
        >
          <i class="material-icons-round">chevron_right</i>
        </v-btn>
        
        <v-chip
          v-if="selectedYear && selectedYear !== currentYear"
          small
          outlined
          color="primary"
          @click="changeYear(currentYear)"
          class="cursor-pointer ms-4"
        >
          <i class="material-icons-round me-1" style="font-size: 16px;">today</i>
          Aktuelles Jahr
        </v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import administrationData from "@/mixins/administrationMixin";

export default {
  name: "YearSelector",
  mixins: [administrationData],
  props: {
    sticky: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canGoPreviousYear() {
      const currentYearValue = this.selectedYear || this.currentYear;
      return currentYearValue > Math.min(...this.getYears);
    },
    canGoNextYear() {
      const currentYearValue = this.selectedYear || this.currentYear;
      return currentYearValue < Math.max(...this.getYears);
    },
  },
  methods: {
    changeYear(year) {
      this.$store.commit('selectedYear', year);
    },
    goToPreviousYear() {
      const currentYearValue = this.selectedYear || this.currentYear;
      if (this.canGoPreviousYear) {
        this.$store.commit('selectedYear', currentYearValue - 1);
      }
    },
    goToNextYear() {
      const currentYearValue = this.selectedYear || this.currentYear;
      if (this.canGoNextYear) {
        this.$store.commit('selectedYear', currentYearValue + 1);
      }
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.year-selector-card {
  display: inline-block;
  width: auto;
}

.year-selector-sticky {
  position: sticky;
  top: 100px;
  z-index: 100;
  background: white;
}
</style>
